import * as React from 'react'

import { Container, Row, Col } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import InfoCard from 'components/Cards/InfoCard'
import StickyChannel from 'components/StickyChannel'
import SimpleTable from 'components/Tables/SimpleTable'
import Button from 'components/Button'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

import { moment } from 'features/Moment'
import { ContactEdit } from 'features/Contacts/ContactEdit'
import { ContactFlowsTimeline } from 'features/Contacts/ContactFlowsTimeline'
import { ContactMessagesTimeline } from 'features/Contacts/ContactMessagesTimeline'
import { IContactClient } from 'features/Contacts/types'
import { contactToForm } from 'features/Contacts/utils'

import { useGetContactQuery } from 'src/generated/graphql'

import { dispatchToProps } from './Contact.container'

import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sMarg from 'styles/modules/margins.scss'
import * as sAnim from 'components/Animation/Animation.scss'

export interface IPageContact {
  contactId: string
  contact?: IContactClient
  loading: boolean
  confirmDeleteContact: typeof dispatchToProps['confirmDeleteContact']
  showContactTriggerFlowModal: typeof dispatchToProps['showContactTriggerFlowModal']
}

export const Contact = (props: IPageContact) => {
  const { contactId, confirmDeleteContact, showContactTriggerFlowModal } = props

  const { data } = useGetContactQuery({
    variables: { id: contactId },
  })
  if (!data || !data.contact) return <LoadingOverlay transparent />

  const { contact } = data
  const phoneNumber = contact && contact.phoneNumbers && contact.phoneNumbers[0]

  return (
    <Page layout={{ header: 'app' }} title="Contacts">
      <PageHeader>
        <Crumbs title="Contacts">
          <Crumb parent to="/dashboard/contacts">
            Contact List
          </Crumb>
          <Crumb active to={`/dashboard/contacts/${contactId}`}>
            {phoneNumber || (contact && contact.id)}
          </Crumb>
        </Crumbs>
      </PageHeader>
      <Container paddingTop paddingBottom className={cn('md', sAnim.comeUp)}>
        {contact && (
          <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'], 'md')}>
            <Col className={cn('md', sLay['flex-gt-xs-60'])}>
              <InfoCard title="Creation Details" className={sMarg.mb30to15}>
                <SimpleTable>
                  <div>
                    <div>Added:</div>
                    <div>{moment(contact.created).format('DD MMM YYYY, h:mm:ss a')}</div>
                  </div>
                  <div>
                    <div>Last edited:</div>
                    <div>{moment(contact.lastEdited).format('DD MMM YYYY, h:mm:ss a')}</div>
                  </div>
                  <div>
                    <div>Last active:</div>
                    <div>{moment(contact.lastActive).format('DD MMM YYYY, h:mm:ss a')}</div>
                  </div>
                </SimpleTable>
              </InfoCard>
              <ContactEdit contact={contactToForm(contact)} />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-40'], 'md')}>
              <StickyChannel>
                <div className={sLay['layout-column']}>
                  <Button
                    className={sMarg.mb15}
                    onClick={() => showContactTriggerFlowModal({ contact })}
                    color="primary"
                    size="sm"
                    rect
                  >
                    Subscribe to a Flow
                  </Button>
                  <Button
                    className={sMarg.mb15}
                    onClick={() => confirmDeleteContact(contactId)}
                    color="warn"
                    size="sm"
                    rect
                  >
                    Delete Contact
                  </Button>
                </div>
                <ContactFlowsTimeline flowLogs={contact.flowLogs?.results || []} />
                <br />
                <br />
                <ContactMessagesTimeline messages={contact.messages?.results || []} />
              </StickyChannel>
            </Col>
          </Row>
        )}
      </Container>
    </Page>
  )
}



// WEBPACK FOOTER //
// src/pages/Contact/Contact.tsx